import { render } from "./GalleryCopy.vue?vue&type=template&id=85b31638&scoped=true"
import script from "./GalleryCopy.vue?vue&type=script&lang=js"
export * from "./GalleryCopy.vue?vue&type=script&lang=js"

import "./GalleryCopy.vue?vue&type=style&index=0&id=85b31638&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85b31638"]])

export default __exports__